export enum CorporateReportTypes {
  Corporate = 'Corporate',
  CorporateTrends = 'Corporate Trends',
  NationalReports = 'National TIM Report',
  TopTransactionsReport = 'National Top Transactions',
  CorporateReportMulti = 'Multi Period Report',
  MoveInOutReport = 'Move In Move Out Report',
}

export enum AsyncCorpReportStatus {
  Completed = 'completed',
  Pending = 'pending',
  Failed = 'failed',
  Processing = 'processing',
  Cancelled = 'cancelled',
  Expired = 'expired',
}

export const GROUPS_COLUMN = 'groups';
export const PIN_COLUMN_OPT = 'pinSubMenu';
export const UNGROUP_ALL_OPT = 'rowUnGroup';
export const RESET_COLUMNS_OPT = 'resetColumns';
